module.exports = __webpack_public_path__ + "static/media/unity.e167612b.svg";